<template>
    <div class="p-4">
        <vx-card class="text-center">

            <img src="@/assets/images/pages/sage/sage_logo.png" alt="Sage Logo" class="mx-auto mb-4" width="120" />

            <div class="mb-4">
                <span v-if="loading" class="text-gray">
                    Checking connection...
                </span>

                <span v-else-if="is_connected" class="text-primary font-semibold">
                    Sage is connected
                    <div>
                        Token expires at: {{status.token_expires_at}}
                    </div>
                </span>

                <span v-else class="text-danger font-semibold">
                    Sage is not connected
                </span>
            </div>

            <div class="flex justify-center space-x-4 mt-8">
                <vs-button v-if="!is_connected" color="primary" :disabled="loading" @click="connectSage">
                    Connect to Sage
                </vs-button>

                <vs-button v-if="is_connected" color="danger" :disabled="loading" @click="disconnectSage">
                    Disconnect Sage
                </vs-button>

                <vs-button color="warning" type="border" :disabled="loading" @click="fetchSageStatus">
                    Refresh Status
                </vs-button>
            </div>

        </vx-card>
    </div>
</template>

<script>

import { RepositoryFactory } from '@/repository/RepositoryFactory'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

const SageRepository = RepositoryFactory.get('sage')

export default {
    name: "ManageSage",
    mixins: [SuccessMessage, ErrorMessages],

    data() {
        return {
            is_connected: false,
            loading: false,
            status: {}
        }
    },

    async mounted() {
        await this.fetchSageStatus()
    },

    methods: {
        async fetchSageStatus() {
            this.loading = true
            try {
                const { data } = (await SageRepository.getSageStatus()).data
                this.status = data
                this.is_connected = this.status.connected
            } catch (error) {
                this.is_connected = false
            } finally {
                this.loading = false
            }
        },

        async connectSage() {
            this.loading = true
            try {
                const { data } = (await SageRepository.getSageAuthUrl()).data
                const stateUrl = new URL(window.location.href)
                stateUrl.searchParams.set("tab", "sage")

                const url = new URL(data.auth_url)
                url.searchParams.set("state", stateUrl.toString())
                const finalUrl = url.toString()
                window.location.replace(finalUrl)
            } catch (error) {
                
            } finally {
                this.loading = false
            }
        },

        async disconnectSage() {
            this.loading = true
            try {
                await SageRepository.disconnectSage()
                await this.fetchSageStatus()
            } catch (error) {
                
            } finally {
                this.loading = false
            }
        }
    }
}
</script>